export default "__VITE_ASSET__9c2f83cd__"